module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("572ZW"))).then(() => module.bundle.root('8rm4T'));